import { connect } from 'react-redux';
import { initialFetch } from './redux/actions';
import { getCanUserHaveWatchedGroups, getMainNavItems, getIsNetworkBarInitialized, getCanUserHaveRecommendedGroups, } from './redux/selectors';
import { getCanUserSeeWatch } from '../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    showWatchedGroupsEmptyState: !getCanUserHaveWatchedGroups(state),
    showRecommendedGroups: getCanUserHaveRecommendedGroups(state),
    mainNavItems: getMainNavItems(state),
    isInitialized: getIsNetworkBarInitialized(state),
    canSeeOldWatch: getCanUserSeeWatch(state),
}); };
var mapDispatchToProps = {
    initialFetch: initialFetch,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=NetworkBar.container.js.map